<template>
    <section class="flex-container my-4" :class="!idComponentePai ? 'card' : ''">
        <div class="flex flex-col gap-2">
            <div class="flex gap-2">
                <label :for="valorInformado">
                    {{ descricao }}
                    <span v-if="respostaObrigatoria == true && idComponentePai != ''" class="text-xs text-vermelho-padrao">*</span>
                </label>
                <Status v-if="idComponentePai == '' || (idComponentePai == '' && resumoModulos == 'false')" :status="statusResposta" />
            </div>
            <input v-if="!resumo" type="text" class="input-padrao" :name="`texto-${valorInformado}`"
                :id="valorInformado" :placeholder="placeholder ?? descricao" v-model="valorInformado"
                 @blur="validarTextoInformado">
            <p v-else><span class="font-semibold">Resposta:</span> {{ valorInformado ?? '-' }}</p>
        </div>
    </section>
</template>

<script>
import { defineComponent } from 'vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import Status from '@/components/Status.vue';
import ComponenteTextoService from '@/services/componentes/ComponenteTextoService'
import ComponentesService from '@/services/ComponentesService'

export default defineComponent({
    name: 'Texto',
    components: {
        Status
    },
    props: {
        ...PropsComponentesConstant.PROPS,
        placeholder: {
            type: String,
            default: ''
        }
    },
    watch: {
        valorInformado: {
            handler(valor) {
                if(!this.resumoModulos) {
                    this.statusResposta = ComponenteTextoService.validarResposta(this.respostaObrigatoria, valor)
                }
            },
            immediate: true
        }
    },
    methods: {
        validarTextoInformado() {
            let resposta = { descricao: this.descricao, resposta: this.valorInformado }
            if(this.respostaObrigatoria && !this.valorInformado) {
                resposta = null
            }
            this.salvarTextoInformado(resposta)
        },
        salvarTextoInformado(resposta) {
            ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaComponente, this.identificador, resposta, this.idComponentePai)
            this.statusResposta = ComponenteTextoService.validarResposta(this.respostaObrigatoria, resposta?.resposta)
        }
    },
    setup(props) {
        return ComponenteTextoService.setup(props)
    }
});
</script>